import { TOKEN_SCOPE } from '@kc-console/context';

export const SCOPE_ORDER = [TOKEN_SCOPE.PROJECT, TOKEN_SCOPE.DOMAIN] as const;
